
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { TeamChatSidebar } from "@/components/team/TeamChatSidebar";
import { TeamChatMessages } from "@/components/team/TeamChatMessages";
import { ClientSupportChats } from "@/components/team/ClientSupportChats";
import { TeamMember } from "@/integrations/supabase/types/";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquare, Users } from "lucide-react";
import { Helmet } from "react-helmet";

const TeamChat = () => {
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);
  const [activeTab, setActiveTab] = useState("team");

  return (
    <div className="container py-6 space-y-6">
      <Helmet>
        <title>Team Chat - Dashboard</title>
      </Helmet>

      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Team Chat</h1>
          <p className="text-muted-foreground mt-2">
            Chat with your team members and clients in real-time
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="team" className="gap-2">
            <Users className="h-4 w-4" />
            Team Chat
          </TabsTrigger>
          <TabsTrigger value="clients" className="gap-2">
            <MessageSquare className="h-4 w-4" />
            Client Support
          </TabsTrigger>
        </TabsList>

        <TabsContent value="team">
          <Card className="flex h-[700px]">
            <TeamChatSidebar
              selectedMember={selectedMember}
              onSelectMember={setSelectedMember}
            />
            <TeamChatMessages selectedMember={selectedMember} />
          </Card>
        </TabsContent>

        <TabsContent value="clients">
          <ClientSupportChats />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TeamChat;
